'use strict';

const canvasCourseIdentity = require('./canvasCourseIdentity');

function getCanvasIntegrationIds(integrations) {
  return (integrations || []).reduce(function (ids, integration) {
    const normalizedId = canvasCourseIdentity.normalizeExternalId(integration && integration.int_id);
    const numericId = Number(normalizedId);

    if (normalizedId !== null && Number.isFinite(numericId) && numericId > 0 && ids.indexOf(numericId) === -1) {
      ids.push(numericId);
    }
    return ids;
  }, []);
}

function getCanvasLinkIntegrationId(integrations, selectedIntegrationId) {
  const integrationIds = getCanvasIntegrationIds(integrations);
  const normalizedSelectedId = canvasCourseIdentity.normalizeExternalId(selectedIntegrationId);
  const selectedId = Number(normalizedSelectedId);

  if (normalizedSelectedId !== null) {
    return Number.isFinite(selectedId) && integrationIds.indexOf(selectedId) !== -1
      ? selectedId
      : null;
  }
  return integrationIds.length ? integrationIds[0] : null;
}

function buildCanvasCourseList(courseResults) {
  return (courseResults || []).reduce(function (courses, result) {
    const integrationId = Number(result && result.integrationId);
    if ((result && result.succeeded === false) ||
        !Number.isFinite(integrationId) || integrationId <= 0 || !Array.isArray(result.courses)) {
      return courses;
    }

    return courses.concat(result.courses.map(function (course) {
      return Object.assign({}, course, {lms_id: integrationId});
    }));
  }, []);
}

function createAvailableCanvasClasses(courseResults, explorosCourses) {
  const results = courseResults || [];
  const successfulResults = results.filter(function (result) {
    return result && result.succeeded !== false;
  });
  const failedResultCount = results.length - successfulResults.length;
  const canvasCourses = buildCanvasCourseList(successfulResults);
  const availableCourses = canvasCourses.filter(function (canvasCourse) {
    return !(explorosCourses || []).some(function (explorosCourse) {
      return canvasCourseIdentity.isImportedCanvasCourse(
        canvasCourse,
        explorosCourse,
        canvasCourse.lms_id
      );
    });
  });

  return {
    courses: availableCourses,
    fetched: successfulResults.length > 0,
    hasCanvasCourses: canvasCourses.length > 0,
    loadFailed: results.length > 0 && successfulResults.length === 0,
    partiallyLoaded: failedResultCount > 0 && successfulResults.length > 0
  };
}

function hasAvailableCanvasCourses(canvasClasses) {
  return Boolean(canvasClasses && Array.isArray(canvasClasses.courses) && canvasClasses.courses.length);
}

module.exports = {
  buildCanvasCourseList,
  createAvailableCanvasClasses,
  getCanvasIntegrationIds,
  getCanvasLinkIntegrationId,
  hasAvailableCanvasCourses
};
